import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '@services/auth.service';
import { OrchestrationAccessService } from '@services/orchestration-access.service';

export function isAiModuleEntry(url: string): boolean {
  const path = url.split('?')[0].split('#')[0];
  return path === '/ai' || path.startsWith('/ai/');
}

/** Paths that only enter the orchestration shell, including legacy redirects into it. */
export function isOrchestrationAdminEntry(url: string): boolean {
  const path = url.split('?')[0].split('#')[0];
  return path.startsWith('/admin/orchestration')
    || path.startsWith('/admin/developer-catalog')
    || path === '/admin/external-service-calls'
    || path === '/admin/notifications'
    || path.startsWith('/admin/notifications/')
    || isAiModuleEntry(path);
}

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private orchestrationAccess: OrchestrationAccessService,
  ) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (!this.authService.isAuthenticated()) {
      return this.router.createUrlTree(['/main-menu']);
    }

    if (this.authService.isAdmin()) {
      return true;
    }

    if (!isOrchestrationAdminEntry(state.url)) {
      return this.router.createUrlTree(['/main-menu']);
    }

    return this.orchestrationAccess.hasOrchestrationAdmin().pipe(
      map(allowed => allowed ? true : this.router.createUrlTree(['/main-menu'])),
    );
  }
}
